import { render, staticRenderFns } from "./Representatives.vue?vue&type=template&id=6d502200&"
import script from "./Representatives.vue?vue&type=script&lang=js&"
export * from "./Representatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports